export enum PurchaseSubHeaderStepEnum {
  SELECT_ITEMS = 'Selecionar itens',
  DETAILING = 'Detalhamento',
  REVIEW_ORDER = 'Revisar pedido',
  SEND_FOR_ANALYSIS = 'Enviar para análise'
}
